export const System = {
  DATAGRID_LICENCE_KEY:
    'AppName=multi_app,Company=TYSOFT,ExpiryDate=2023-05-19,LicenseDeveloperCount=1,LicenseType=multi_app,Ref=TYSOFTLicenseRef,Z=1235901805-1126857021-443215353-208157853712359018051826537251',
  STORAGE_CACHE_DURATION: 1 * 60 * 60,
  USER_DATA_DURATION: 5, // in minutes
  UPLOAD_MAX_SIZE: 5000000,
  RETRY_MAX_ATTEMPTS: {
    api: 3,
    component: 3,
  },
  STORAGE_CACHE_ID: 3,
  NINA_NOTION_PAGE_ID: '9b19809226cf4b24acb8b6a193fc6a2b',
  // TODO : use env variable instead of hardcoded value
  // MUI_LICENSE_KEY: process.env.VITE_APP_MUI_PRO_LICENSE_KEY ?? '',
  MUI_LICENSE_KEY:
    'f595f68c7540f4a9976adfa9439da825Tz0xMDIyOTcsRT0xNzYzOTA1MTA1MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=',
  DEFAULT_FIRST_WEEKDAY: 1,
  SWITCH_MANAGEMENT_CENTER_VIEW_KEY: 'isManagementCenterViewKey',
};
